import api from '@/services/api';
import { normalizeAmountString } from '@shared/components/form/config-value';
import type { RecordedTopUp, TopUpInput, TopUpPayload } from '../types/topUps.types';

export const toTopUpPayload = (input: TopUpInput): TopUpPayload => ({
    amount_gross: normalizeAmountString(input.amountGross) ?? input.amountGross,
    payment_reference: input.paymentReference.trim(),
    taking_dealer_id: input.takingDealerId,
});

const mapRecordedTopUp = (raw: Record<string, unknown>): RecordedTopUp => ({
    id: String(raw.id ?? ''),
    kind: String(raw.kind ?? ''),
    amount: String(raw.amount ?? ''),
    collectedAt: String(raw.collected_at ?? ''),
    reference: String(raw.reference ?? ''),
    takingDealerId: typeof raw.taking_dealer_id === 'string' ? raw.taking_dealer_id : null,
});

export const recordTopUp = async (agreementId: string, input: TopUpInput): Promise<RecordedTopUp> => {
    const response = await api.post(`/agreements/${agreementId}/top-ups`, toTopUpPayload(input));
    return mapRecordedTopUp(response.data.data);
};
